<script>
  export let slug = false;
  export let showTooltip;
  export let header = '';
  export let subhead = '';
  export let values = [];
</script>

<div
  id={slug}
  class="tooltip"
  class:invisible={!showTooltip}
  data-show-tooltip={showTooltip}
>
  <div>
    {#if header}
      <p class="tooltip__header">{header}</p>
    {/if}
    {#if subhead}
      <p class="tooltip__subheader">{subhead}</p>
    {/if}
    {#each values as obj}
      <p class="tooltip__value">
        {@html obj}
      </p>
    {/each}
  </div>
</div>